import * as Blockly from 'blockly/core';
import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
import { createMinusField } from '../fields/field_minus';
import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';

// const plusImage =
//     'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC' +
//     '9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMT' +
//     'ggMTBoLTR2LTRjMC0xLjEwNC0uODk2LTItMi0ycy0yIC44OTYtMiAybC4wNzEgNGgtNC4wNz' +
//     'FjLTEuMTA0IDAtMiAuODk2LTIgMnMuODk2IDIgMiAybDQuMDcxLS4wNzEtLjA3MSA0LjA3MW' +
//     'MwIDEuMTA0Ljg5NiAyIDIgMnMyLS44OTYgMi0ydi00LjA3MWw0IC4wNzFjMS4xMDQgMCAyLS' +
//     '44OTYgMi0ycy0uODk2LTItMi0yeiIgZmlsbD0id2hpdGUiIC8+PC9zdmc+Cg==';

// const minusImage =
//     'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAw' +
//     'MC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPS' +
//     'JNMTggMTFoLTEyYy0xLjEwNCAwLTIgLjg5Ni0yIDJzLjg5NiAyIDIgMmgxMmMxLjEwNCAw' +
//     'IDItLjg5NiAyLTJzLS44OTYtMi0yLTJ6IiBmaWxsPSJ3aGl0ZSIgLz48L3N2Zz4K';

// 30x30px white image of '(' sign, white color
// const paramOpenImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA40lEQVRIS+2WzQmDQBBG19zSQ8BKhHSRLizCFizBCnIMeLeHpAWvXt/m4A/LhxCUnRUh77TMDDx2XHfHuT9nAWiATuOmAJ2fAFrNmwDUgXQAHloTHaCcpZO40proADkwBNKn1pgAtIH0rXkTgGLp7ygutcYEoIm124sGfnAP1q9gbQeQS5sLrTFBfyHNb2Vrq51zznnvPxrbyi5xDPaKrxrYyi5xlmU3jZmxcqrtH4UZoA/EjebNkHu617wZK3d1rTVmyNSRdNf6HqcZedwor5Z+H9Dy5aAdIQ+/d/IRt00uPSVfgRhK5e4wQzIAAAAASUVORK5CYII=';

// 10x30px white image of '(' sign, white color
// const paramOpenWhiteImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAAzElEQVQ4T72TvQ3CQAyFX+jYASmTRGILtsgQWSEjZAJKpPTZAVZIm/YdxSXGPEySBr7Ksj+d78cH/BWSHclB82+QHNIMyV7rQJZaJ00kL+qAZL1Is9ioA5IlyclJV3WALPZOumsdyFJl/bJYqwPMV7G22sHFZxffXPyCZCltK3WA4Eq0DmkNAEgpPTSHSPxGJB41gUgsiuKkOSM49ecQLJAcndhp3ZB3HrVuBG/dqmPIVK+uqvMYfwFkubH+O7ZgB9sj+/1uftl+U/o9T5OySuWDwN4aAAAAAElFTkSuQmCC';

// 10x30px white image of '(' sign, white color
// const paramOpenYellowImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA+ElEQVQ4T72TMXLCMBBFnz2UpKDkEDTcgDQMJ2CGK3ADbsAF0vsAlKkZilDmDKFKaVtQMrspAGW1NnEa+NXq7xt9jbSCp0pq1lKz8X4iqdloQDWgEih8HwAJrAxUSsXUM0jF4gZpQOXI0jPIiaEEygjVvHkGLpGFifzwfQCkZJxEViw8A9er+Gu33NQzU7+b+ldyYpjElow9c9nxzCQxB3zaNS4aAIW992gD76kJKi/eog3MMkbeI4I9ttZsG4IcIO/zrXCIbsarhXDRu1hlzI2fqvHWgZVnotxUf/l+VGMe730BADmy/P8RzAB3w/a8nV82UHRCj9cPECXHpL0X13wAAAAASUVORK5CYII=';

// 30x30px white image of ')' sign, white color
// const paramCloseImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA+UlEQVRIS+2WsQ3CMBBFbRahYgcaJLZgA8oMwQoZgQlSIST6NGxACQ1SWkT3TBNLx8kSjuFc8arL3Ulf/+zYdu5PAqAHOp03BejDCNDreikznUhwjoH3flnVOdBG16Pzne4xAzgJ4Qcw1z0mAHNgEOI/W++PJEa+0j1mKNd7Xc8lZ1drDiJei9gWYCPHreumSGGg0fUcSkbtQgg3nZtKkbBz7qkTUykV/poiYe/9QnzeRWwHsJKbS9dzKXG8jUEI4fJeyqdEWB4aRxHbATTi/616Q12FcJ0HAdAJ0aGK28R1WHRMTiIh2uoeE9Qrs866RsZ3dR2nf37NCx+uIWyGPd1nAAAAAElFTkSuQmCC';

// 10x30px white image of ')' sign, white color
// const paramCloseWhiteImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA2klEQVQ4T8WTvQ3CMBBGP7MIFTvQILEFG1BmCFZgBCagQkj0adiAEhokWkT3TEEcLpdLOsSrzuenzz+ypZ8A1MDe9zsAdW4Aaj9fmEg6l0FKaT6aDGxLapO88U4LcDLiE5h6R/qIU+Bh5MH9RltYeKfFpe5Kf9LVJEkHUy9N3QVY2eX9fAcrApUGllbO+eZ7oSjp5RtDYo9QTCnNzPBu6i/Awh6m9KPEdSlyzpdSR6K95KOpvwCVub/RF3Q1YvyAgb2RHmFa8Lwq70TS1jtS/xfG+yo0/zpO+j9vaFohbE2OHjMAAAAASUVORK5CYII=';

// 10x30px white image of ')' sign, white color
// const paramCloseYellowImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA8ElEQVQ4T8WTsXHDMAxFH7WFh3DjMhukTeM7r5ANvEEWcO8yhcq0KdOlSRbwAjmZtGsgTSBRIOxz48urgM9//0ARgrsgmV4yO6/PkEyvBdWCSqb350ZH4tOalHi6miyFraVqQeXEs/eMSGE/GguDnFl4DwByZiGFwy3ztiMMrLxnxKW+mN7NbYDyWnWPVkTGdytTYjk/dMzmPLIhTARU+fZaaCRx8lJsDAiNCR6q9qeqJ2RgVV/G9DaxY22lwsckt4wfGXir6gk5srltgzJf1TvHCyyZXZV2CNOa9fp7tuumwtZ7oP0L47kMyfQXk/6fX9DOx055W0vhAAAAAElFTkSuQmCC';

/**
 * Reusable brick block definition.
 * @type {{
 *   init: Blockly.Blocks.vmt_reusable_brick_init.init
 * }}
 */
Blockly.Blocks['vmt_reusable_brick_init'] = {
    /**
    * Initializes the block.
    * @this {Blockly.Block}
    */
    init: function () {
        this.jsonInit({
            // "type": "vmt_reusable_brick_init",
            message0: "%1 %2",
            message1: "%1",
            args0: [
                {
                    "type": "field_input",
                    "name": "REUSABLE_BRICK_DESCIPTION",
                    "text": "<description>"
                },
                {
                    type: 'input_dummy',
                    name: 'TOP',
                },
            ],
            args1: [
                {
                    "type": "input_statement",
                    "name": "REUSABLE_BRICK_STATEMENT",
                    "check": ["Brick", "null"]
                }
            ],

            previousStatement: ["Brick", "null"],
            nextStatement: ["Brick", "null"],
            colour: REUSABLE_BRICK_COLOR,
            tooltip: "",
            helpUrl: "",
            mutator: "new_parameter_create_with_mutator"
        });
    },

    /**
     * Returns the list of parameter blocks used in the block.
     * @this {Blockly.Block}
     * @return {Array<Blockly.Block>|[]} The list of parameter blocks.
     * @private
     */
    getUsedParamBlocks: function () {
        const allRBBlocks = this.getDescendants();
        // const allRBBlocks = this.workspace.getAllBlocks();//this.getDescendants();
        const paramBlocks = [];
        allRBBlocks.forEach((block) => {
            if (block.type === 'vmt_parameter_reference') {
                paramBlocks.push(block);
            }
        });
        return paramBlocks;
    },

    /**
     * Returns the list of parameter blocks that are not connected to any field.
     * @this {Blockly.Block}
     * @return {Array<Blockly.Block>|[]} The list of parameter blocks.
     * @private
     */
    getUnpluggedParams: function () {
        const allBlocks = this.workspace.getAllBlocks()
        const paramBlocks = [];
        allBlocks.forEach((block) => {
            if (block.type === 'vmt_parameter_reference') {
                if (!block.outputConnection.targetConnection) {
                    paramBlocks.push(block);
                }
            }
        });
        return paramBlocks;
    },

    /**
     * Renames a parameter.
     * @param {string} fieldName The name of the source field.
     * @param {string} oldName The old name of the parameter.
     * @param {string} newName The new name of the parameter.
     * @this {Blockly.Block}
     * @private
     * @return {void}
     */
    renameParamBlocks_: function (fieldName, oldName, newName) {
        console.log('renameParam', fieldName, oldName, newName);
        const paramBlocks = [...this.getUsedParamBlocks(), ...this.getUnpluggedParams()];
        // const paramBlocks = this.getUnpluggedParams();
        paramBlocks.forEach((block) => {
            if (block.getFieldValue('PARAM_ID') === fieldName) {
                block.setFieldValue(newName, 'PARAMETER_NAME');
            }
        });
    },

    /**
     * Removes paremeter blocks associated with the given field name and replaces
     * with  the field/parameter value block(s).
     * @param {string} fieldName The name of the source field.
     * @this {Blockly.Block}
     * @private
     * @return {void}
     */
    removeParamBlocks_: function (fieldName) {
        console.log('removeParamBlocks_', fieldName);
        const paramInput = this.getField(fieldName).getParentInput();
        const paramInputBlock = paramInput.connection.targetBlock();
        console.log('paramInputBlock', paramInputBlock);


        /* @type {Blockly.BlockSvg} */
        // const targetCloneBlock = Blockly.clipboard.paste(copyData2, workspace);

        /** @type {Array<Blockly.Block>|[]} */
        const paramBlocks = this.getUsedParamBlocks();
        paramBlocks.forEach((block) => {
            if (block.getFieldValue('PARAM_ID') === fieldName) {
                if (paramInputBlock) { // if there is a block connected to the field
                    const targetConnection = block.outputConnection.targetConnection;
                    if (targetConnection) { // if there is a block connected to the parameter
                        targetConnection.disconnect();
                        const copyData = paramInputBlock.toCopyData();
                        const paramInputBlockCopy = /** @type {Blockly.BlockSvg} */ (
                            Blockly.clipboard.paste(copyData, this.workspace)
                        );
                        if (!targetConnection.connect(paramInputBlockCopy.outputConnection)) { // if the connection is not successful
                            paramInputBlockCopy.dispose();
                        }
                    }
                }
                block.unplug();
                block.setParent(null);
                block.dispose();
            }
        });

        /** @type {Array<Blockly.Block>|[]} */
        const unusdeParamBlocks = this.getUnpluggedParams();
        unusdeParamBlocks.forEach((block) => {
            block.dispose();
        });

        if (paramInputBlock) {
            paramInputBlock.dispose();
        }
    },
};

const parameterCreateMutator = {
    /**
     * An array of objects containing data about the params belonging to the
     * reusable block definition.
     * @type {!Array<{
     *          name:string,
     *          paramId: string
     *       }>}
     * @private
     */
    paramData_: [],

    /**
     * Creates XML to represent number of text inputs.
     * @returns {!Element} XML storage element.
     * @this {Blockly.Block}
     */
    mutationToDom: function () {
        const container = Blockly.utils.xml.createElement('mutation');
        this.paramData_.forEach((element) => {
            const argument = Blockly.utils.xml.createElement('param');
            argument.setAttribute('name', element.name);
            argument.setAttribute('paramId', element.paramId);
            container.appendChild(argument);
        });
        return container;
    },
    /**
     * Parses XML to restore the text inputs.
     * @param {!Element} xmlElement XML storage element.
     * @this {Blockly.Block}
     */
    domToMutation: function (xmlElement) {
        const names = [];
        const paramIds = [];
        for (const childNode of xmlElement.childNodes) {
            if (childNode.nodeName.toLowerCase() === 'param') {
                names.push(childNode.getAttribute('name'));
                paramIds.push(childNode.getAttribute('paramId'));
            }
        }
        this.updateShape_(names, paramIds);
    },

    /**
     * Returns the state of this block as a JSON serializable object.
     * @returns {{itemCount: number}} The state of this block, ie the item count.
     */
    saveExtraState: function () {
        if (!this.paramData_.length && this.hasStatements_) {
            return null;
        }

        const state = Object.create(null);
        if (this.paramData_.length) {
            state['params'] = [];
            this.paramData_.forEach((param) => {
                state['params'].push({
                    name: param.name,
                    paramId: param.paramId,
                });
            });
        }
        if (!this.hasStatements_) {
            state['hasStatements'] = false;
        }
        return state;
    },

    /**
     * Applies the given state to this block.
     * @param {*} state The state to apply to this block, ie the item count.
     */
    loadExtraState: function (state) {
        const names = [];
        const paramIds = [];
        if (state['params']) {
            for (let i = 0; i < state['params'].length; i++) {
                const param = state['params'][i];
                names.push(param['name']);
                paramIds.push(param['paramId']);
            }
        }
        this.updateShape_(names, paramIds);
    },

    /**
     * Adds inputs to the block until it reaches the target number of inputs.
     * Adds arguments to the block until it matches the targets.
     * @param {!Array<string>} names An array of argument names to display.
     * @param {!Array<string>} paramIds An array of parameter IDs associated with
     *     those names.
     * @this {Blockly.Block}
     * @private
     */
    updateShape_: function (names, paramIds) {
        if (names.length !== paramIds.length) {
            throw Error('names and paramIds must have the same length.');
        }
        // Usually it's more efficient to modify the block, rather than tearing it
        // down and rebuilding (less render calls), but in this case it's easier
        // to just work from scratch.

        // We need to remove params in reverse order so that it doesn't mess up
        // as removeParams_ modifies our array.
        for (let i = this.paramData_.length - 1; i >= 0; i--) {
            this.removeParam_(this.paramData_[i].paramId);
        }
        this.paramData_ = [];
        const length = paramIds.length;
        for (let i = 0; i < length; i++) {
            this.addParam_(names[i], paramIds[i]);
        }
    },

    /**
     * Callback for the plus image. Adds an input to the end of the block and
     * updates the state of the plus.
     * @this {Blockly.Block}
     * @private
     */
    plus: function () {
        console.log('plus');
        this.addParam_();
    },

    /**
     * Callback for the minus image. Removes an input from the end of the block
     * and updates the state of the minus.
     * @param {string} paramId The ID of the parameter to remove
     * @this {Blockly.Block}
     * @private
     */
    minus: function (paramId) {
        console.log('minus');
        this.removeParam_(paramId);
    },

    /**
     * Adds an input to the end of the block. If the block currently has no
     * inputs it updates the top 'EMPTY' input to receive a block.
     * @this {Blockly.Block}
     * @private
     */
    addParam_: function (name = null, paramId = null) {
        const paramNames = this.paramData_.map((param) => param.name);
        name =
            name ||
            Blockly.Variables.generateUniqueNameFromOptions(
                Blockly.Procedures.DEFAULT_ARG,
                paramNames,
            );

        paramId = paramId || Blockly.utils.idGenerator.genUid();

        // add input
        // const nameField = new Blockly.FieldTextInput(name, this.validator_);
        const parameterInputName = `PARAMETER_INPUT_${paramId}`;
        const parameterDeleteButtonName = `PARAMETER_DELETE_BUTTON_${paramId}`;
        const parameterNameField = `PARAMETER_NAME_${paramId}`;

        const nameField = new VmtFieldFlyoutText(name);
        nameField.setSpellcheck(false);
        nameField.paramName_ = name;
        nameField.paramId_ = paramId;
        nameField.onFinishEditing_ = this.finishEditing_.bind(nameField);

        const paramValueInput = this.appendValueInput(parameterInputName);
        paramValueInput.paramName_ = name;
        paramValueInput.paramId_ = paramId;
        // this.appendDummyInput(parameterInputname)
        // this.appendValueInput(parameterInputName)
        paramValueInput
            .setAlign(Blockly.inputs.Align.RIGHT)
            // .appendField(new Blockly.FieldImage(minusImage, 15, 15, undefined, this.onMinusClick_), parameterDeleteButtonName)
            .appendField(createMinusField(paramId), parameterDeleteButtonName)
            .appendField(nameField, parameterNameField);

        this.moveInputBefore(parameterInputName, 'REUSABLE_BRICK_STATEMENT');
        this.paramData_.push({ name, paramId });
    },

    /**
     * Called when the field is finished editing. Renames the parameter if the
     * name has changed. If the name is already in use, it will append a number
     * to the end to make it unique.
     * @param {string} _finalName The final value of the field.
     * @this {VmtFieldFlyoutText}
     * @private
     */
    finishEditing_: function (_finalName) {
        console.log('finishEditing_', _finalName);
        const sourceBlock = this.getSourceBlock();
        const thisField = this;
        if (thisField.paramName_ !== _finalName) {
            const thisBlock = thisField.getSourceBlock();
            const paramNames = thisBlock.paramData_.map((param) => param.name);
            let finalNextUniqueName = _finalName;
            let finalUniqueName = finalNextUniqueName;

            let iteration = 0, uniqueName = '';
            do {
                finalUniqueName = finalNextUniqueName
                uniqueName = Blockly.Variables.generateUniqueNameFromOptions(
                    finalUniqueName,
                    paramNames,
                )
                finalNextUniqueName = `${finalUniqueName}_${++iteration}`;
            } while (uniqueName !== finalUniqueName && iteration < 100);  // prevent infinite loop

            // rename all instances of this parameter
            sourceBlock.renameParamBlocks_(thisField.paramId_, thisField.paramName_, finalUniqueName);

            // update the field
            this.setValue(finalUniqueName);
            this.paramName_ = finalUniqueName;
            console.log('finishEditing_ finalUniqueName', finalUniqueName);
            thisBlock.paramData_.find((param) => param.paramId === thisField.paramId_).name = finalUniqueName;
            thisBlock.saveExtraState();
        }
    },

    /**
     * Removes an input from the block.
     * @param {string} paramId The ID of the parameter to remove.
     * @this {Blockly.Block}
     * @private
     */
    removeParam_: function (paramId) {
        const index = this.paramData_.findIndex((param) => param.paramId === paramId);
        if (index === -1) {
            return;
        }
        this.onBeforeRemoveInput_(`PARAMETER_NAME_${paramId}`);
        this.removeInput(`PARAMETER_INPUT_${paramId}`);
        this.paramData_.splice(index, 1);
    },

    /**
     * Called before removing an input. Can be overridden to perform operations
     * before removing an input.
     * @param {string} inputName The name of the input to remove.
     * @this {Blockly.Block}
     * @protected
     * @return {void}
     */
    onBeforeRemoveInput_: function (inputName) {
        console.log('onBeforeRemoveInput_', inputName);
        this.removeParamBlocks_(inputName);
    },  // end onBeforeRemoveInput_
};

/**
 * Updates the shape of the block to have 3 inputs if no mutation is provided.
 * @this {Blockly.Block}
 */
const parameterCreateHelper = function () {
    this.paramData_ = [];
    // this.parameterCount_ = 0;

    this.getInput('TOP').insertFieldAt(0, createPlusField(), 'PLUS');
};

Blockly.Extensions.registerMutator(
    'new_parameter_create_with_mutator',
    parameterCreateMutator,
    parameterCreateHelper,
);
